import React from "react";
import APIService from "../../Service/APIService";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import { Button } from "antd";
import { Modal, Form, Row, Col } from "antd";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import SectionHeader from "../../common/section-header/index.js";

const ChildAccounts = (props) => {
  const { user, isReady } = useAuth();
  const userData = user;
  const { accountData, handleLinkChange, accountOptions, allAccountsData } =
    props;
  const readOnly = props.readOnly === true;
  const [childAccounts, setChildAccounts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedChildAccount, setSelectedChildAccount] = React.useState(null);
  const navigate = useNavigate();

  const [newAccountOptions, setNewAccountOptions] = React.useState(null);

  const getAllChildAccount = async () => {
    if (accountData && accountData?.ID) {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `getallchildaccounts/?ParentAccountID=${accountData.ID}`
      );
      // console.log("Child Accounts: ", response?.data?.data);
      setChildAccounts(response?.data?.data);
    }
  };
  React.useEffect(() => {
    // console.log("Account Options Props: ", accountOptions);
    const tempOptions = accountOptions.filter(
      (account) => account.value !== accountData?.ID && account.value !== "Self"
    );
    // console.log("tempAccountOptions: ", tempOptions);
    setNewAccountOptions(tempOptions);
    getAllChildAccount().finally(() => setLoading(false));
  }, []);
  const [modalChildVisible, setModalChildVisible] = React.useState(false);
  const handleModalOk = () => {
    setModalChildVisible(false);
  };
  const handleModalCancel = () => {
    setModalChildVisible(false);
  };
  const handleChildNew = () => {
    if (readOnly) return;
    // setModalChildVisible(true);
    navigate(
      `/Account?tab=details&paID=${accountData.ID}&paName=${encodeURIComponent(
        accountData.AccountName
      )}`
    );
    window.location.reload();
  };
  const addChildAccount = async () => {
    if (readOnly) return;
    if (selectedChildAccount && accountData) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to add this account as a child account?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const apiServe = new APIService();
          const postObj = {
            ParentAccountID: accountData.ID,
            ChildAccountID: selectedChildAccount,
          };
          const response = await apiServe.updateDataToBackend(
            postObj,
            "updateaccount?type=AddChild"
          );
          Swal.fire({
            icon: "success",
            title: "Child Account Added",
            text: "Child Account has been added successfully",
          }).then(() => {
            window.location.reload();
          });
        }
      });
      // console.log("Add Child Account Response: ", response);
      // getAllChildAccount();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a child account to add",
      });
    }
  };
  return (
    <div>
      {/* {accountData && */}
      <div>
        <SectionHeader
          title="Child Accounts"
          buttonLabel="Add Child Account"
          onButtonClick={handleChildNew}
          showButton={userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.edit") && !readOnly}
        />
        <GenericDashboard
          data={childAccounts}
          screen="ChildAccounts"
          handleLinkChange={handleLinkChange}
          loading={loading}
        />
        {!readOnly && hasPermission(userData, "manage_accounts.edit") && <div>
          <Modal
            open={modalChildVisible}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            centered={true}
            footer={null}
            style={{ width: "800px" }}
          >
            <div style={{ padding: "10px 20px 20px 20px" }}>
              <h3>Add Child Account</h3>
              <Form layout="vertical">
                <Row gutter={16}>
                  <Col span={18}>
                    <Form.Item label="Account Name">
                      <Select
                        defaultValue="Choose Account"
                        onChange={(value) =>
                          setSelectedChildAccount(value.value)
                        }
                        options={newAccountOptions}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  type="primary"
                  style={{ background: "#27a907" }}
                  onClick={addChildAccount}
                >
                  Add Child Account
                </Button>
              </Form>
            </div>
          </Modal>
        </div>}
      </div>
      {/* } */}
    </div>
  );
};

export default ChildAccounts;
